import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { httpss } from '../../utils/host';
import { GlobalState } from '../../store/GlobalState';
import logoMyH from '../../assets/images/logo-myH.png'
export default function FanPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState([]);
  const [fanpages, setFanpages] = useState([]);
  const [pageDetails, setPageDetails] = useState([]);
  const [selectedPageId, setSelectedPageId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(50);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const accessToken = sessionStorage.getItem('accessToken');
  const fetPage = async (page = 1, limit = postsPerPage, pageId = selectedPageId) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      if (pageId) {
        params.append('pageId', pageId);
      }
      const response = await axios.get(`${httpss}/apis_v1/admin/getDataPage?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` } });
      if (response.data.data) {
        setData(response.data.data);
        setPagination(response.data.pagination);
        if (!selectedPageId && response.data.data.length > 0) {
          setSelectedPageId(response.data.data[0].id.toString());
        }
      } else {
        setData(response.data);
        if (!selectedPageId && response.data.length > 0) {
          setSelectedPageId(response.data[0].id.toString());
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetPage();
  }, []);

  useEffect(() => {
    if (selectedPageId) {
      fetPage(currentPage, postsPerPage, selectedPageId);
    }
  }, [selectedPageId, currentPage, postsPerPage]);

  const handlePageSelect = (event) => {
    setSelectedPageId(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleLimitChange = (event) => {
    setPostsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };
  const selectedPage = Array.isArray(data) && data.find((fanpage) => fanpage.id === parseInt(selectedPageId));

  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1303634020222700', // replace with your Facebook app ID
        cookie: true,
        xfbml: true,
        version: 'v20.0',
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/vi_VN/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, []);

  const handleConnectFanpage = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          setIsAuthenticated(true);
          fetchFanpages();
        }
      },
      { scope: 'pages_show_list,pages_read_engagement,pages_read_user_content' }
      // { scope: 'pages_show_list' }
    );
  };

  const fetchFanpages = () => {
    window.FB.api('/me/accounts', function (response) {
      if (response && !response.error) {
        const userAccessToken = window.FB.getAuthResponse()?.accessToken; // lấy user token
        setFanpages(response.data);
        
        response.data.forEach((page) => {
          fetchPageDetails(page, userAccessToken); // truyền vào
        });
      }
    });
  };

  const fetchPageDetails = (page, userAccessToken) => {
    const fetchPosts = (url) => {
      window.FB.api(
        url,
        { access_token: page.access_token },
        (response) => {
          if (response && !response.error) {
            const pageDetailsWithToken = {
              ...response,
              access_token: page.access_token,
              user_access_token: userAccessToken, // Gửi thêm về
              page_id: page.id,
            };
  
            setPageDetails((prevDetails) => {
              const updatedDetails = [...prevDetails, pageDetailsWithToken];
              savePageDetailsToDatabase(pageDetailsWithToken);
              return updatedDetails;
            });
  
            if (response.posts?.paging?.next) {
              fetchPosts(response.posts.paging.next);
            }
          } else {
            console.error("Error fetching page posts:", response.error);
          }
        }
      );
    };
  
    const url = `/${page.id}?fields=picture,name,posts{message,created_time,full_picture,permalink_url,reactions,comments,shares}`;
    fetchPosts(url);
  };
  
  const savePageDetailsToDatabase = async (pageDetails) => {
    await axios.post(`${httpss}/apis_v1/admin/savePageDetails`, pageDetails)
      .then(response => {
        console.log('Page details saved successfully:', response.data);
        fetPage()
      })
      .catch(error => {
        console.error('Error saving page details:', error);
      });
  };

  const handleDisconnectFanpage = async (id) => {
    try {
      const response = await fetch(`${httpss}/apis_v1/admin/deleteFanpage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });
      if (response.ok) {
        const result = await response.json();
        alert(result.message); 
        fetPage();
      } else {
        console.error('Error:', response.status);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  
  return (
    <div className="p-4 bg-gray-50 min-h-screen max-h-screen overflow-y-auto">
      <div className='sticky top-0 z-0 flex justify-end bg-white rounded-lg p-2 mb-4 shadow'>
        <div className="flex gap-3">
          <button
            onClick={fetPage}
            className="bg-blue-500 hover:bg-blue-400 text-white px-5 py-2 rounded-lg font-semibold shadow"
          >
            Reload
          </button>
          <button
            onClick={handleConnectFanpage}
            className="bg-blue-500 hover:bg-blue-400 text-white px-5 py-2 rounded-lg font-semibold shadow"
          >
            {isAuthenticated ? 'Connected' : 'Connect Fanpage Facebook'}
          </button>
        </div>
      </div>
        {Array.isArray(data) && data.map((fanpage) => (
        <div key={fanpage.id} className="flex justify-between items-center gap-4 p-4 bg-white rounded-xl shadow mb-4">
          <div className="flex items-center gap-4">
            <img
              src={fanpage.picture}
              alt={fanpage.name}
              className="w-16 h-16 rounded-full border object-cover shadow-sm"
            />
            <div>
              <h3 className="text-xl font-semibold text-gray-800">{fanpage.name}</h3>
              <p className="text-sm text-gray-500">🆔 FanPage ID: {fanpage.FanPageId}</p>
              <p className="text-sm text-gray-500">📝 Posts: {fanpage?.PostFBs?.length || 0}</p>
            </div>
          </div>

          {/* Action Button */}
          <div className="text-right">
            <button
              onClick={() => handleDisconnectFanpage(fanpage.id)}
              className="bg-red-500 hover:bg-red-400 text-white px-5 py-1.5 rounded-full font-semibold shadow"
            >
              Disconnect
            </button>
            <p className="text-sm text-gray-500 mt-1">
              ⏰ Token expires: {new Date(fanpage.user_token_expires_at).toLocaleString('vi-VN')}
            </p>          </div>
        </div>
      ))}

    </div>
  );
}
